export const MIXPANEL_EVENTS_NAMING = {
  // ----- Annotation Explorer Specific
  // The "Switch to old / new layout" link on the Highlights listing: how many
  // people leave the table for the card grid (and come back).
  ANNO_LAYOUT_SWITCHED: {
    eventName: "Highlights Layout Switched",
    properties: {
      FEATURE: "Feature",
      // the layout switched TO: "cards" | "table"
      LAYOUT: "Layout",
    },
  },
  CARD_CLICKED: {
    eventName: "Card Clicked",
    properties: {
      FEATURE: "Feature",
      CONTENT_TYPE: "Content Type",
      CONTENT_TITLE: "Content Title",
      ANNOTATION: "Annotation",
      // Where the card was shown, when not on the Annotation Explorer page itself
      SURFACE: "Surface",
      WIDGET: "Widget",
      REPORT_ID: "Report ID",
      WIDGET_ID: "Widget ID",
      WIDGET_INDEX: "Widget Index",
    },
  },
};
